import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Skeleton} from './../../components/Skeleton';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 4fr 0.7fr;
  grid-column-gap: 16px;
  grid-row-gap: 8px;
  margin-bottom: 8px;
`;
const StyledSkeleton = styled(Skeleton)`
  height: 24px;
`;
type UserStatsSkeletonProps = {
  numUsers: number;
};
export const UserStatsSkeleton = ({numUsers}: UserStatsSkeletonProps) => {
  return (
    <Grid>
      {Array(numUsers)
        .fill('')
        .map((_, i) => (
          <React.Fragment key={i}>
            <StyledSkeleton />
            <StyledSkeleton />
          </React.Fragment>
        ))}
    </Grid>
  );
};
